export default "__VITE_ASSET__d38e6d3d__"